import { render, staticRenderFns } from "./VlExaminationTableData.vue?vue&type=template&id=8822fbe4&"
import script from "./VlExaminationTableData.vue?vue&type=script&lang=js&"
export * from "./VlExaminationTableData.vue?vue&type=script&lang=js&"
import style0 from "./VlExaminationTableData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports